export enum ReadStatus {
  UNSET = 'UNSET',
  READ = 'READ',
  UNREAD = 'UNREAD',
}
